export function parseRestEndpointData(endpoint, body, filters, urlParse, contentType) {
    const eventBody = {
        url: endpoint.url,
        filters,
        body,
        contentType,
    };
    if (filters) {
        const filtersAsUrlParams = Object.keys(filters)
            .reduce((filterStrings, k) => {
                filterStrings.push(`${k}=${encodeURIComponent(filters[k])}`);
                return filterStrings;
            }, [])
            .join('&');

        const fullUrl = `${endpoint.url}?${filtersAsUrlParams}`;

        eventBody.url = fullUrl;
    }

    if (typeof urlParse === 'object' && urlParse !== null) {
        Object.keys(urlParse).forEach(key => {
            eventBody.url = eventBody.url.replace(key, urlParse[key]);
        });
        // console.log("\n\nNEW URL for eventBody", eventBody);
    }

    if (typeof endpoint.method === 'string' && endpoint.method !== 'GET') {
        eventBody.method = endpoint.method;
    }
    if (typeof endpoint.contentType === 'string') {
        eventBody.contentType = endpoint.contentType;
    }
    return eventBody;
}
